import React from 'react';
import tw, { css } from 'twin.macro';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

interface Props {
  isOpen: boolean;
  onClick: () => void;
  position?: 'left' | 'right';
  className?: string;
}

export function MobileToggleButton(props: Props) {
  const { isOpen, onClick } = props;
  const OpenIcon =
    props.position === 'left' ? ChevronLeftIcon : ChevronRightIcon;
  const CloseIcon =
    props.position === 'left' ? ChevronRightIcon : ChevronLeftIcon;
  return (
    <div
      className={props.className}
      css={[
        isOpen && tw`-right-4`,
        !isOpen &&
          css`
            left: calc(100% - 16px);
          `,
        tw`block md:hidden absolute top-1 z-20 border rounded-full cursor-pointer`,
      ]}
    >
      <button
        type="button"
        css={[
          tw`rounded-full bg-white p-1 text-neutral-moderate shadow-sm`,
          tw`transform transition-all ease-in-out`,
          !isOpen && tw`hover:pl-3`,
          isOpen && tw`hover:pr-3`,
        ]}
        onClick={() => onClick()}
      >
        {isOpen && <OpenIcon tw="h-5 w-5" />}
        {!isOpen && <CloseIcon tw="h-5 w-5" />}
      </button>
    </div>
  );
}
